import React from 'react';
import { Button } from 'reactstrap';

const MissionControlLogsButton = (props) => {
    const instanceId = props.instanceId;

    const envVariable = process.env.REACT_APP_MISSION_CONTROL_KIBANA_LOGS_URL;
    const modifiedLink = envVariable.replaceAll('{InstanceId}', instanceId);

    return (
        <Button
            className="m-2"
            color="primary"
            href={modifiedLink}
            target="_blank">
            View Mission Control Logs
        </Button>
    );
};

export default MissionControlLogsButton;
